import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import { ExportReactCSV } from "hearing/components/partials/csv";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

export default function SimpleTable(props) {
  const classes = useStyles();

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="right">Study ID</TableCell>
            <TableCell align="right">Participant ID</TableCell>
            <TableCell align="right">Spreadsheet for Tobi</TableCell>
            <TableCell align="right">Operation</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            props.data.map(data => {
              return (
                <TableRow>
                  <TableCell align="right">{data.studyId}</TableCell>
                  <TableCell align="right">{data.participantId}</TableCell>
                  <TableCell align="right"><ExportReactCSV data={data.tobiDatas} headers={data.tobiHeaders} fileName={"irsm_tobi_data"} /></TableCell>
                  <TableCell align="right"><Button style={{color: "white", backgroundColor: "#107896" }} onClick={() => props.deleteData(data._id)}>Delete</Button></TableCell>
                </TableRow>
              )
            })
          }
        </TableBody>
      </Table>
    </TableContainer>
  );
}
